module.exports = __webpack_public_path__ + "img/0cde77e.png";